import { useLang } from "../i18n/LangContext";

export const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <section data-testid="marquee-section" className="border-y border-line py-8 md:py-10 overflow-hidden bg-ink-2">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center font-display text-4xl md:text-6xl px-8 md:px-12">
                <span className={i % 2 ? "italic text-gold" : "text-[var(--bone)]"}>{w}</span>
                <span className="ml-16 md:ml-24 w-2 h-2 rotate-45 bg-[var(--gold)]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
